export default __webpack_public_path__ + "static/media/20211007_120240.854e02c4.png";